import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9 } from "styled-components";
import React from "react";
import { Button } from "~/features/ui/button";
import { Link } from "~/features/ui/link";
import { Headline } from "~/features/ui/headline";
import { IconButton } from "~/features/ui/icon-button";
import { stripHtmlTags } from "~/features/app/utils";
import Plus from "~/public/icons/plus.svg";
import ArrowRight from "~/public/icons/arrow-right.svg";
export type GeneralCardViewProps = {
  headline?: string;
  text?: React.ReactNode;
  url?: string;
  linkText?: string;
  hasPlusIcon?: boolean;
  media?: React.ReactNode;
};
export function GeneralCardView(props: GeneralCardViewProps) {
  const {
    headline,
    text,
    url,
    media,
    linkText,
    hasPlusIcon = true
  } = props;
  const content = <_StyledDiv>
      <_StyledDiv2>
        {!Boolean(linkText) && hasPlusIcon && <_StyledDiv3>
            <IconButton as="div" icon={{
          component: Plus
        }} />
          </_StyledDiv3>}
        {media}
      </_StyledDiv2>

      <_StyledDiv4>
        {headline && <_StyledHeadline type="h2" text={headline} />}
        {text && <_StyledDiv5>{text}</_StyledDiv5>}
        {url && Boolean(linkText) && <_StyledDiv6>
            <Button as="div" icon={ArrowRight} variant="underline">
              {linkText}
            </Button>
          </_StyledDiv6>}
      </_StyledDiv4>
    </_StyledDiv>;
  if (url) {
    return <_StyledLink href={url}>
        {content}
      </_StyledLink>;
  }
  return <_StyledDiv7>{content}</_StyledDiv7>;
}
type Props = Omit<GeneralCardViewProps, "text"> & {
  text?: string;
};
export function GeneralCard({
  text,
  ...rest
}: Props) {
  return <GeneralCardView {...rest} text={text ? <p>{stripHtmlTags(text)}</p> : undefined} />;
}
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-sf-988thz-0"
})({
  "display": "flex",
  "flex": "1 1 0%",
  "flexDirection": "column",
  "gap": "2.4rem",
  "@media (min-width: 1024px)": {
    "gap": "4rem"
  }
});
var _StyledDiv2 = _styled2("div").withConfig({
  componentId: "sc-sf-988thz-1"
})({
  "position": "relative"
});
var _StyledDiv3 = _styled3("div").withConfig({
  componentId: "sc-sf-988thz-2"
})({
  "position": "absolute",
  "bottom": "var(--spacing-sm)",
  "right": "var(--spacing-sm)",
  "zIndex": "10"
});
var _StyledDiv4 = _styled4("div").withConfig({
  componentId: "sc-sf-988thz-3"
})({
  "display": "flex",
  "flex": "1 1 0%",
  "flexDirection": "column"
});
var _StyledHeadline = _styled5(Headline).withConfig({
  componentId: "sc-sf-988thz-4"
})({
  "fontSize": "2rem",
  "lineHeight": "1.3",
  "letterSpacing": "0.02rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "2.4rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.024rem",
    "fontWeight": "400"
  }
});
var _StyledDiv5 = _styled6("div").withConfig({
  componentId: "sc-sf-988thz-5"
})({
  "marginTop": "1.6rem",
  "fontSize": "1.4rem",
  "lineHeight": "1.5",
  "letterSpacing": "0.014000000000000002rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "1.4rem",
    "lineHeight": "1.5",
    "letterSpacing": "0.014000000000000002rem",
    "fontWeight": "400"
  }
});
var _StyledDiv6 = _styled7("div").withConfig({
  componentId: "sc-sf-988thz-6"
})({
  "marginTop": "auto",
  "paddingTop": "4rem"
});
var _StyledLink = _styled8(Link).withConfig({
  componentId: "sc-sf-988thz-7"
})({
  "position": "relative",
  "display": "flex",
  "height": "100%",
  "flexDirection": "column"
});
var _StyledDiv7 = /*#__PURE__*/_styled9("div").withConfig({
  displayName: "general-card___StyledDiv7",
  componentId: "sc-1h447x1-0"
})({
  "position": "relative",
  "display": "flex",
  "height": "100%",
  "flexDirection": "column"
});